<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">메뉴 관리</h2>
        <div class="admin-manage-btn-top">
            <button type="button" class="sysadmin-default-btn" @click="showModal=true">생성</button>
        </div>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>메뉴 관리</caption>
              <colgroup>
                <col style="width:10%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:10%">
              </colgroup>
              <tr>
                <th>순서</th>
                <th>메뉴명</th>
                <th>URL</th>
                <th>비고</th>
                <th>상태</th>
              </tr>
              <tr v-for="(item, index) in this.getAdminMenus" v-bind:key="index" @click="fnModify(item)">
                  <td>{{ item.orderSeq }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.url }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.statusName }}</td>
                  <td></td>
              </tr>
            </table>
          </div>
        </section>
        <modal v-if="showModal" @close="showModal=false">
            <h3 slot="body">
                <div class="form-modal-container">
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-orderseq">순서 *</label>
                        <input
                            v-model.trim="orderSeq"
                            class="default-input form-input"
                            type="text"
                            id="report-orderseq"
                            placeholder="순서">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-name">메뉴명 *</label>
                        <input
                            v-model.trim="name"
                            class="default-input form-input"
                            type="text"
                            id="report-name"
                            placeholder="메뉴명">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-url">URL *</label>
                        <input
                            v-model.trim="url"
                            class="default-input form-input"
                            type="text"
                            id="report-url"
                            placeholder="url">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                            <label class="form-label" for="report-description">비고</label>
                            <input
                              v-model.trim="description"
                              class="default-input form-input"
                              type="text"
                              id="report-description"
                              placeholder="비고">
                        </div>
                    </div>
                    <div class="form-modal" v-if="flag === 'U'">
                        <div class="input-area">
                            <label class="form-label" for="report-status">사용여부</label>
                            <select name="state-select" id="state-select" class="default-select" v-model="statusCode">
                                <option v-for="(type) in this.getStatuses" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-btn-area">
                    <button type="button" class="modal-btn-save" @click="save()">저장</button>
                    <button type="button" class="modal-btn-cancle" @click="cancle()">닫기</button>
                </div>
            </h3>
        </modal>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import Modal from '@/components/AdminModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminMenu',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'modal': Modal
  },
  data () {
    return {
      id: '',
      name: '',
      orderSeq: '',
      url: '',
      description: '',
      statusCode: '',
      statusTitle: '',
      flag: 'C',
      showModal: false
    }
  },
  created () {
    this.setInit({'method': 'GET'})
  },
  methods: {
    ...mapActions({
      setInit: 'apiSysadminMenus'
    }),
    fnModify (item) {
      this.id = item.id
      this.name = item.name
      this.orderSeq = item.orderSeq
      this.url = item.url
      this.description = item.description
      this.statusCode = item.statusCode
      this.statusTitle = item.statusName
      this.flag = 'U'
      this.showModal = true
    },
    save () {
      if (this.orderSeq === '' || this.name === '' || this.url === '') {
        alert('필수값을 입력해주세요.')
        return
      }
      if (this.flag === 'U') { // 수정일 경우
        const params = {
          'id': this.id,
          'description': this.description,
          'name': this.name,
          'orderSeq': this.orderSeq,
          'status': this.statusCode,
          'url': this.url,
          'method': 'PATCH'
        }
        this.$store.dispatch('apiSysadminMenus', params)
      } else { // 생성일 경우
        const params = {
          'description': this.description,
          'name': this.name,
          'orderSeq': this.orderSeq,
          'status': 'ENABLED',
          'url': this.url,
          'method': 'POST'
        }
        this.$store.dispatch('apiSysadminMenus', params)
      }
      // this.initValues()
    },
    cancle () {
      this.initValues()
    },
    initValues () {
      this.id = ''
      this.name = ''
      this.orderSeq = ''
      this.url = ''
      this.description = ''
      this.statusCode = ''
      this.statusTitle = ''
      this.showModal = false
      this.flag = 'C'
    }
  },
  computed: {
    ...mapGetters(['getAdminMenus', 'getStatuses'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminMenu.vue